import axios from "axios";

export default {
  data() {
    return {
      apiUrl: this.mfConfig?.api,
      tenantId: this.realm,
      flows: [],
    };
  },
  mounted() {
    this.mashupId = window.location.pathname
      .split("draw/")
      .pop()
      .split("/v")[0];
    this.mashupVersion = window.location.pathname
      .split("v/")
      .pop()
      .split("/edit")[0];
    this.getFlows();
  },
  methods: {
    getFlows() {
      axios
        .get(
          this.apiUrl +
            "/" +
            this.tenantId +
            "/flows" +
            "?project=" +
            this.mashupId +
            "&version=" +
            this.mashupVersion,
          this.opts,
        )
        .then((response) => {
          this.flows = response.data;
        })
        .catch((err) => {
          this.setError(err, false);
        });
    },
  },
};
